// pattern: Imperative Shell

import Router from '@substrate-system/routes'
import { HomeRoute } from './home.js'
import { AboutRoute } from './about.js'

export default function _Router ():InstanceType<typeof Router> {
    const router = new Router()

    router.addRoute('/', () => {
        return HomeRoute
    })

    router.addRoute('/about', () => {
        return AboutRoute
    })

    return router
}

export const routes = [
    { href: '/', text: 'home', title: 'Easy Open API' },
    { href: '/about', text: 'about', title: 'About — Easy Open API' }
]

export function titleForRoute (path:string):string {
    const match = routes.find(r => r.href === path)
    return match ? match.title : 'Easy Open API'
}
